import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=c65fdfc4&scoped=true"
import script from "./CityList.vue?vue&type=script&lang=js"
export * from "./CityList.vue?vue&type=script&lang=js"
import style0 from "./CityList.vue?vue&type=style&index=0&id=c65fdfc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65fdfc4",
  null
  
)

export default component.exports